import { otaUpdatesUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";

export const getInstallationProcessList = async (
  namespace: string,
  source_id: string,
  signal: AbortSignal,
) => {
  const url = otaUpdatesUrlEnvVar();
  const headers = {
    ...buildAxiosAuthenticationHeaders(),
  };

  try {
    const response = await axios.get(
      `${url}/api/v2/ns/${namespace}/installation-process`,
      {
        headers: headers,
        params: {
          source_id: source_id,
        },
        signal: signal,
      },
    );

    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      const message =
        err.response?.data?.detail ||
        err.response?.data?.message ||
        "Failed to fetch installation processes. Please try again later.";

      throw new Error(message);
    } else {
      throw new Error(
        "An unexpected error occurred while fetching installation processes.",
      );
    }
  }
};
